import { motion } from "framer-motion";

export function MaskLines({ lines, className = "", delay = 0, as: Tag = "h1", testid }) {
  return (
    <Tag className={className} data-testid={testid}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${l.className || ""}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {l.text}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Reveal({ children, className = "", delay = 0, y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
